import { QuestionPropertyValidator } from 'app/models/questions/property-validator/QuestionPropertyValidator'
import { IMatrix } from 'app/interfaces/IMatrix'
import { KanoStatementKeyValidationError } from 'app/custom-errors/KanoStatementKeyValidationError'
import { IRow } from 'app/interfaces/IRow'
import { OpenColsValidationError } from 'app/custom-errors/OpenColsValidationError'
import { ViewerTypeEnum } from 'app/enums/ViewerTypeEnum'

export class MatrixPropertyValidator extends QuestionPropertyValidator implements IMatrix {
  rows: {[p: string]: IRow}
  rowsOrder: string[]
  randomizeRows: boolean

  constructor(question) {
    super(question)

    this.rowsOrder = question.rowsOrder
    this.rows = question.rows
    this.randomizeRows = question.randomizeRows
    if (!question.extra_raw){
      this.validateKanoStatementKeys()
    }
    this.validateOpenColsProperty()
    this.validateOpenColsValues()
    this.validateOpenColsKeys()
  }

  validateOpenColsProperty() {
    this.rowsOrder.forEach(rKey => {
      if (!this.rows[rKey].openCols) {
        throw new OpenColsValidationError(this.viewerType, this.key, rKey).missingOpenCols()
      }
    })
  }

  validateOpenColsKeys() {
    this.rowsOrder.forEach(rKey => {
      const openCols = this.rows[rKey].openCols
      if (!Object.keys(this.statements).every(key => Object.keys(openCols).includes(key))) {
        throw new OpenColsValidationError(this.viewerType, this.key, rKey).compareKeyValues(Object.keys(this.rows[rKey].openCols), Object.keys(this.statements))
      }
    })
  }

  validateOpenColsValues() {
    const questionTypesWithOpenColsToTrue = [
      ViewerTypeEnum.OPEN,
      ViewerTypeEnum.PROPS,
      ViewerTypeEnum.PHONE,
      ViewerTypeEnum.ADDRESS,
      ViewerTypeEnum.NAME,
      ViewerTypeEnum.EMAIL
    ]

    if (questionTypesWithOpenColsToTrue.includes(this.viewerType)) {
      const rowKey = this.rowsOrder[this.rowsOrder.length - 1]

      const openColValues = Object.values(this.rows[rowKey].openCols)

      if (!openColValues || !openColValues.length) {
        throw new OpenColsValidationError(this.viewerType, this.key, rowKey)
      }
      openColValues.forEach(v => {
        if (v !== true) {
          throw new OpenColsValidationError(this.viewerType, this.key, rowKey)
        }
      })
    }
  }

  validateKanoStatementKeys() {

    if (!(this.viewerType === ViewerTypeEnum.KANO)) {
      return
    }

    const actualStatementKeys = new Set()
    Object.keys(this.statements).forEach(sKey => {
      actualStatementKeys.add(sKey)
    })

    for (const labelKey in expectedKanoStatementKeys) {
      const statementLabel = expectedKanoStatementKeys[labelKey]
      if (!actualStatementKeys.has(statementLabel)) {
        throw new KanoStatementKeyValidationError(Array.from(actualStatementKeys) as string[], this.key)
      }
    }
  }
}

export const expectedKanoStatementKeys = ['kano_Satisfied', 'kano_Expected', 'kano_Not_Expected', 'kano_Not_Satisfied']
